import { missingWidget } from '../../utils/helpers';

export default function headlineFirst() {
  const widgetName = 'headlineFirst';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof headlineFirstOpts === 'undefined' ? null : headlineFirstOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createheadlineFirst(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createheadlineFirst(widgetData) {
    const { Title } = widgetData.items[0];

    $widget.replaceWith(`<h3 class="headline first-headline">${Title}</h3>`);
  }
}
